export enum GTM_PLAN_UPDATE_EVENTS {
  UPGRADE = 'plan-upgrade',
  DOWNGRADE = 'plan-downgrade',
  CANCELLATION = 'plan-cancellation',
}
